var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.url},on:{"error":_vm.onError}}),_c('portal',{attrs:{"to":"toolbar"}},[(_vm.selected)?_c('ImageToolbar'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }